import React, { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { NoSsr, Typography } from "@mui/material";
import MetaData from "../meta-data";
import MainLayout from "../../components/layout/MainLayout";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import useGetCategories from "../../api-manage/hooks/react-query/categories-details/useCategoriesDetails";
import useGetCategoriesForStore from "../../api-manage/hooks/react-query/categories-details/useCategoriesDetailsForStore";
import {
  CustomPaperBigCard,
  CustomStackFullWidth,
} from "../../styled-components/CustomStyles.style";
import CategoriesDetails from "../../components/categories-details";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";


const Index = () => {
  const { configData, landingPageData, loading } = useConfigData();
  const router = useRouter();
  const [type, setType] = useState("all");
  const [offset, setOffset] = useState(1);
  const [page_limit, setPageLimit] = useState(10);
  
  const id = router.query.id?.split("-")[0];
  const [category_id, setCategoryId] = useState(id);

  const { data, isLoading, isRefetching, refetch } = useGetCategories({
    category_id,
    type,
    offset,
    page_limit
  });

  const { data: storeData, isLoading: itemIsLoading, refetch: storeRefetch } = useGetCategoriesForStore({
    category_id,
    type,
    offset,
    page_limit
  });
  
  useEffect(() => {
    if (id && id !== category_id) {
      setCategoryId(id);
    }
  }, [id]);
  
  useEffect(() => {
    type && setOffset(1);
  }, [type]);
  
  useEffect(() => {
    if (category_id) {
      refetch();
      storeRefetch();
    }
  }, [category_id, type, offset, refetch, storeRefetch]);

  if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading...
            </div>
        );
    }

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Category` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <CustomStackFullWidth>
          <CustomPaperBigCard nopadding="true" sx={{ padding: "1rem" }}>
            <NoSsr>
              <CategoriesDetails
                id={id}
                data={data}
                category_id={category_id}
                setCategoryId={setCategoryId}
                storeData={storeData}
                offset={offset}
                type={type}
                setType={setType}
                page_limit={page_limit}
                setOffset={setOffset}
                isLoading={isLoading}
                isRefetching={isRefetching}
                itemIsLoading={itemIsLoading}
              />
            </NoSsr>
          </CustomPaperBigCard>
        </CustomStackFullWidth>
      </MainLayout>
    </>
  );
};

export default Index;
